function calculateWeekRange(today: Date) {
  const currentDay = today.getDay();
  const diffToMonday = currentDay === 0 ? 6 : currentDay - 1;

  const startOfWeek = new Date(today);
  startOfWeek.setDate(today.getDate() - diffToMonday);

  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(startOfWeek.getDate() + 6);

  return { startOfWeek, endOfWeek };
}

export function getCurrentWeekDatesAndRange(): string {
  const today = new Date();
  const { startOfWeek, endOfWeek } = calculateWeekRange(today);

  const startDay = startOfWeek.getDate();
  const endDay = endOfWeek.getDate();
  const startMonth = startOfWeek.toLocaleString('default', { month: 'long' });
  const endMonth = endOfWeek.toLocaleString('default', { month: 'long' });

  return startMonth === endMonth
    ? `${startDay} - ${endDay} ${endMonth}`
    : `${startDay} ${startMonth} - ${endDay} ${endMonth}`;
}
